import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { DemoModal } from "../components/DemoModal";

const DemoContext = createContext({ openDemo: () => {} });

export const useDemo = () => useContext(DemoContext);

export const DemoProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, productId: null });

  const openDemo = useCallback((productId = null) => {
    setState({ open: true, productId });
  }, []);
  const closeDemo = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  const value = useMemo(() => ({ openDemo }), [openDemo]);

  return (
    <DemoContext.Provider value={value}>
      {children}
      <DemoModal open={state.open} productId={state.productId} onClose={closeDemo} />
    </DemoContext.Provider>
  );
};
